import {Auditable} from "../shared/auditable.model";
import {UserModel} from "./user.model";
import {FileModel} from "../shared/file.model";

export class VendorModel extends Auditable {
  id: number;
  name: string = '';
  notes: string = '';

  account_id: number = 0;

  email = '';
  website = '';

  phone = '';
  phone_e164: string = '';
  phone_country_code: string = '';
  phone_dial_code: string = '';

  address = '';
  suburb = '';
  city = '';
  postal_code = '';
  country = '';

  is_prequalified: boolean = false;
  prequalified_date: string;

  insurance_valid_till: string;
  insurance_last_verified_by: number = null;
  insurance_last_verified_date: number = null;

  linked_assets_count: number = 0;

  /**
   * Who created this Vendor?
   */
  created_by_user: UserModel;

  /**
   * Who updated this Vendor?
   */
  updated_by_user: UserModel;

  /**
   * Who last verified the insurance of this Vendor?
   */
  insurance_last_verifier: UserModel;

  files: FileModel[] = [];
}
